module.exports = __webpack_public_path__ + "img/cartaz-mobile.a9562ebf.jpg";